import styled from "styled-components";

export const StyledStyledFeaturedMatchPromo = styled.div`
  width: 100%;

  .mls-c-match-promo {
    padding: 16px;
    border-radius: 5px;
    background-color: ${({ theme }) => theme.rgba.white_240};

    .mls-c-match-promo__promo-link-button {
      margin-top: 12px;
    }
  }
`;
